const warehouseReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_WAREHOUSE':
            const newState = action.payload;
            return newState;
        case 'UNSET_WAREHOUSE':
            return [];
        default:
            return state;
    }
};

export default warehouseReducer;